import React from "react";

import MainLayout from "./main";
import Task from "../contexts/task/task";

const TaskLayout = (props) => {
    return (
        <MainLayout>
            <Task settings={props}>{props.children}</Task>
        </MainLayout>
    );
};

export default TaskLayout;
